<mat-menu class="elm-time-menu">
  <ng-template matMenuContent>
    <button mat-menu-item *ngFor="let item of times; trackBy: trackByTime" (click)="onSelected(item.value)">
      {{ item.name }}
    </button>
  </ng-template>
</mat-menu>
